import { render, staticRenderFns } from "./cashbook-table.vue?vue&type=template&id=7313fdae&scoped=true&"
import script from "./cashbook-table.vue?vue&type=script&lang=js&"
export * from "./cashbook-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7313fdae",
  null
  
)

export default component.exports